import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const PageHeader = ({ eyebrow, title, intro, testid }) => (
  <section className="px-6 md:px-16 lg:px-24 pt-20 pb-12 md:pt-28" data-testid={testid}>
    <Reveal>
      <p className="eyebrow mb-5">{eyebrow}</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05] max-w-4xl">{title}</h1>
      {intro && <p className="mt-6 max-w-2xl text-base md:text-lg text-[#5C5A56] leading-relaxed">{intro}</p>}
    </Reveal>
  </section>
);
